import React from 'react';
import { Container } from './primitives';
import { BrandMark } from '../ui/BrandMark';
import { useBranding } from '../../context/BrandingContext';
import { BrandLinks, PoweredBy, useCopyrightNotice } from '../ui/BrandFooter';

export const AppFooter: React.FC = () => {
  const { branding } = useBranding();
  const copyright = useCopyrightNotice();

  return (
    // data-theme-scope: when a footer colour is set, the theme replaces this
    // gradient with it and supplies readable text colours (theme/engine.ts).
    <footer data-theme-scope="footer" className="w-full bg-[radial-gradient(circle_at_20%_20%,rgb(var(--c-584ab4,88_74_180)/0.38),transparent_35%),radial-gradient(circle_at_75%_25%,rgb(var(--c-1b5b99,27_91_153)/0.35),transparent_40%),linear-gradient(105deg,rgb(var(--c-151722,21_23_34)),rgb(var(--c-10151e,16_21_30))_55%,rgb(var(--c-101a26,16_26_38)))] px-10 py-8">
      <Container size="wide">
        <div className="flex w-full flex-col items-center justify-between gap-4 text-center md:flex-row md:text-left">
          <div className="flex flex-col items-center gap-1 md:items-start">
            <BrandMark className="h-10 w-auto" onDark />
            {branding.tagline && (
              <p className="text-xs text-kv-agentic-cyan">{branding.tagline}</p>
            )}
          </div>

          <BrandLinks className="text-sm text-[rgb(var(--theme-footer-muted,var(--c-d2d7ea,210_215_234)))]" />

          <div className="flex flex-col items-center gap-1 md:items-end">
            {copyright && <p className="text-xs text-[rgb(var(--theme-footer-muted,var(--c-d2d7ea,210_215_234)))]">{copyright}</p>}
            <PoweredBy className="text-xs text-[rgb(var(--theme-footer-muted,var(--c-d2d7ea,210_215_234)))]" />
          </div>
        </div>
      </Container>
    </footer>
  );
};
